<div class="navigation-button interactive-button container" [ngClass]="{disabled: isDisabled}" fxLayout="row"
     fxLayoutAlign="start center"
     fxLayoutGap="10px" [routerLink]="[path]" routerLinkActive="active"
     [matTooltip]="condensedMode ? ('NAV_LABEL_' + label | translate) : null"
     matTooltipPosition="right">
  <div class="active-indicator"></div>
  <div class="icon-container" fxLayoutAlign="center center">
    <fa-icon [icon]="icon"></fa-icon>
  </div>
  <div class="interactive-label" *ngIf="!condensedMode">{{ 'NAV_LABEL_' + label | translate }}</div>
</div>
